import { Link } from "react-router-dom";

export default function ThanksPage() {
  return (
    <div className="min-h-screen bg-white">
      <header className="sticky top-0 z-10 bg-white/95 backdrop-blur-sm border-b border-gray-100">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="text-sm font-semibold text-teal-700 hover:text-teal-800">
            ← トップへ戻る
          </Link>
          <span className="text-sm text-gray-500">株式会社つくし映像</span>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-3xl border border-gray-100 shadow-sm p-8 sm:p-12">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">送信ありがとうございました</h1>
          <p className="mt-6 text-lg text-gray-700 leading-relaxed">
            無料見積もり依頼を送信しました。通常２営業日以内に折り返しご連絡させていただきますが、お急ぎの場合は、080-2250-4380（受付時間：9時〜17時）までお問い合わせください。
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Link
              to="/"
              className="inline-flex items-center justify-center px-8 py-3 bg-teal-600 text-white text-base font-bold rounded-full hover:bg-teal-700 transition-colors"
            >
              トップページへ
            </Link>
            <a
              href="tel:08022504380"
              className="inline-flex items-center justify-center px-8 py-3 bg-gray-900 text-white text-base font-bold rounded-full hover:bg-gray-800 transition-colors"
            >
              電話する（9時〜17時）
            </a>
          </div>
        </div>
      </main>

      <footer className="border-t border-gray-100 py-8">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-sm text-gray-500 flex items-center justify-between">
          <span>&copy; 2026 株式会社つくし映像</span>
          <Link to="/" className="text-teal-700 hover:text-teal-800">トップへ</Link>
        </div>
      </footer>
    </div>
  );
}

